import { useTranslation } from 'react-i18next';
import './MealTable.css';
import { isMobile } from 'react-device-detect';

export const MealTable = ({ meal, isPeopleDeclared }) => {
    const { t } = useTranslation('recipe');
    return (
        <table className={isPeopleDeclared ? 'peopleIsDeclared card-table' : 'peopleIsNotDeclared card-table'}>
            {!isMobile
                ? <thead>
                <tr>
                    <th className={'th'}>{t('title')}</th>
                    <th className={'th'}>{t('recipeText')}</th>
                    <th className={'th'}>{t('todayMenu:products')}</th>
                </tr>
                </thead>
                : <></>}
            <tbody>
            {meal == null || meal.length === 0 ? <></> : meal.map((recipe, index) => {
                return (
                    <tr key={index} className={isMobile ? 'mobile-card-row' : ''}>
                        <td className={isMobile ? '' : 'td width-15'}>{recipe.title}</td>
                        <td className={isMobile ? '' : 'td width-70'}>{recipe.recipeText}</td>
                        <td className={isMobile ? '' : 'td width-15'}>{recipe.recipeItems.map((item, itemIndex) => {
                            return (
                                <li key={index + 'item' + itemIndex}>
                                    {item.productName} {item.amountGrossKg} {t('common:unit.kg')}
                                </li>
                            );
                        })}</td>
                    </tr>
                );
            })}
            </tbody>
        </table>
    );
};